import { Dispatch } from "redux";
import ImagerApi from "../api/ImagerApi";
import {
  ImagerCapability,
  LightPathCapability,
  LightPathCollection,
} from "../Model/ImagerCapabilities";
import {
  fetchImagerCapabilitiesError,
  fetchImagerCapabilitiesPending,
  fetchImagerCapabilitiesSuccess,
} from "../redux/actions/ImagerCapabilitiesActions";
import { Collection } from "./../Model/Collection";

export function getLightpathCollection(
  lightpaths: LightPathCapability[]
): LightPathCollection {
  let lightpathCollection: LightPathCollection = {
    allIds: [],
    byId: {},
  };

  for (let i = 0; i < lightpaths.length; i++) {
    const lightPath = lightpaths[i].lightpath;
    lightpathCollection.allIds.push(lightPath);
    lightpathCollection.byId[lightPath] = lightpaths[i];
  }
  return lightpathCollection;
}

export function getImagerCapabilitiesCollection(
  imagerCapabilities: ImagerCapability[]
): Collection<ImagerCapability> {
  
  let imagerCapabilitiesCollection: Collection<ImagerCapability> = {
    allIds: [],
    byId: {},
  };

  for (let i = 0; i < imagerCapabilities.length; i++) {
    const identifier = imagerCapabilities[i].identifier.toString();
    imagerCapabilitiesCollection.allIds.push(
      imagerCapabilities[i].identifier
    );
    const lightpathCollection = getLightpathCollection(
      imagerCapabilities[i].capabilities
    );
    const imagerCapability: ImagerCapability = {
      supportedArmTypes: imagerCapabilities[i].supportedArmTypes,
      identifier: identifier,
      capabilities: imagerCapabilities[i].capabilities,
      isPlateBumpSupported: imagerCapabilities[i].isPlateBumpSupported,
      lightpathCollection: lightpathCollection,
    };

    imagerCapabilitiesCollection.byId[identifier] = imagerCapability;
  }

  return imagerCapabilitiesCollection;
}

export function fetchImagerCapabilities() {
  return (dispatch: Dispatch) => {
    dispatch(fetchImagerCapabilitiesPending());
    ImagerApi.getCapabilities()
      .then((imagerCapabilities) => {
        
        const imagerCapabilitiesCollection = getImagerCapabilitiesCollection(imagerCapabilities); 

        console.log("DEBUG", "fetchImagerCapabilities", {
          imagerCapabilitiesCollection,
        });

        dispatch(fetchImagerCapabilitiesSuccess(imagerCapabilitiesCollection));
        return imagerCapabilitiesCollection;
      })
      .catch((error) => {
        dispatch(fetchImagerCapabilitiesError(error));
      });
  };
}
